import { render } from "./edit-item.vue?vue&type=template&id=0339af3e&scoped=true"
import script from "./edit-item.vue?vue&type=script&lang=js"
export * from "./edit-item.vue?vue&type=script&lang=js"

import "./edit-item.vue?vue&type=style&index=0&id=0339af3e&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0339af3e"]])

export default __exports__